import { render } from "./TableUsers.vue?vue&type=template&id=6c8286f4"
import script from "./TableUsers.vue?vue&type=script&lang=js"
export * from "./TableUsers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__